<template>
  <div class="col-9">
    <p class="pre_line">
      <strong>{{ item.text }}</strong>
    </p>
    <ol v-if="item.is_multichoice" type="a">
      <div
        v-for="(val, idx) in [1, 2, 3, 4, 5, 6]"
        :key="`item-${item.id}-${idx}`"
      >
        <li v-if="showItem(val)" :class="answerClass(val)">
          {{ getChoice(val) }}
        </li>
      </div>
    </ol>
    <div v-if="!item.is_multichoice" style="padding-top: 1.75rem;">
      <span v-if="!item.answer">[ No answer entered yet ]</span>
      {{ item.answer }}
    </div>
    <div v-if="action == 'mark'" class="marking">
      <div class="btn-group">
        <button
          class="btn-danger btn-small"
          v-bind:class="{ outline: markIsSelected(-1) }"
          v-on:click="markItem(-1)"
        >
          Incorrect
        </button>
        <button
          class="btn-info btn-small"
          v-bind:class="{ outline: markIsSelected(1) }"
          v-on:click="markItem(1)"
        >
          Part Marks
        </button>
        <button
          class="btn-success btn-small"
          v-bind:class="{ outline: markIsSelected(2) }"
          v-on:click="markItem(2)"
        >
          Correct
        </button>
      </div>
    </div>
  </div>
</template>
<style>
.marking {
  padding-top: 1.2rem;
  padding-bottom: 0;
}
</style>
<script>
export default {
  name: "exam-item-view",
  props: {
    item: {},
    examId: Number,
    action: String
  },
  methods: {
    answerClass: function(idx) {
      /* Logic:
       *
       * 1. Selected answer is correct = Green
       *
       * 2. Selected answer is wrong = Red
       *
       * 3. If wrong highlight correct answer in Purple.
       * */
      const choice = this.getChoice(idx);
      if (choice == this.item.answer) {
        if (this.item.assessment >= 2) {
          // Selected answer is correct
          return "success";
        } else {
          // Selected answer is wrong
          return "error";
        }
      } else if (choice == this.item.correct_answer) {
        return "selected";
      } else {
        return "";
      }
    },
    markIsSelected: function(value) {
      return !(value == this.item.assessment);
    },
    markItem(value) {
      this.$store.dispatch("exams/updateItem", {
        examId: this.examId,
        itemId: this.item.id,
        assessment: value
      });
    },
    showItem: function(idx) {
      return this.item["choice_" + idx].length > 0;
    },
    getChoice: function(idx) {
      return this.item["choice_" + idx];
    }
  }
};
</script>
